import React from 'react';
import { CheckCircle2, Award } from 'lucide-react';
import { qualityManagement } from '../mockData';

const QualityManagement = () => {
  return (
    <section id="quality" className="py-20 bg-slate-50">
      <div className="container mx-auto px-4">
        {/* Section Header */}
        <div className="max-w-3xl mx-auto text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-slate-900 mb-4">
            {qualityManagement.title}
          </h2>
          <div className="w-24 h-1 bg-blue-600 mx-auto mb-6"></div>
          <p className="text-lg text-slate-600 leading-relaxed">
            {qualityManagement.description}
          </p>
        </div>

        {/* Quality Process Timeline */}
        <div className="max-w-4xl mx-auto mb-16">
          <div className="space-y-8">
            {qualityManagement.processes.map((process, index) => (
              <div key={process.step} className="relative">
                {/* Connector Line */}
                {index < qualityManagement.processes.length - 1 && (
                  <div className="absolute left-6 top-16 w-0.5 h-16 bg-blue-200 hidden md:block"></div>
                )}
                
                <div className="flex gap-6 items-start">
                  {/* Step Number */}
                  <div className="flex-shrink-0">
                    <div className="w-12 h-12 bg-blue-600 text-white rounded-full flex items-center justify-center font-bold text-lg shadow-lg">
                      {process.step}
                    </div>
                  </div>
                  
                  {/* Content */}
                  <div className="flex-1 bg-white rounded-xl p-6 shadow-md border-2 border-slate-100 hover:border-blue-600 transition-all duration-300">
                    <h3 className="text-xl font-bold text-slate-900 mb-2">
                      {process.title}
                    </h3>
                    <p className="text-slate-600 leading-relaxed">
                      {process.description}
                    </p>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>

        {/* Certifications */}
        {qualityManagement.certifications.length > 0 && (
          <div className="bg-white rounded-2xl p-8 md:p-12 shadow-xl">
            <div className="grid lg:grid-cols-2 gap-12 items-center">
              <div>
                <h3 className="text-3xl font-bold text-slate-900 mb-6 flex items-center gap-3">
                  <Award className="text-blue-600" size={36} />
                  Certifications & Compliance
                </h3>
                <p className="text-slate-600 mb-8 leading-relaxed">
                  Our commitment to excellence is validated by industry-leading certifications 
                  and compliance standards. We continuously invest in training and process 
                  improvements to maintain these high standards.
                </p>
                <div className="space-y-4">
                  {qualityManagement.certifications.map((cert, index) => (
                    <div key={index} className="flex items-center gap-3 bg-slate-50 p-4 rounded-lg">
                      <CheckCircle2 className="text-blue-600 flex-shrink-0" size={24} />
                      <span className="font-semibold text-slate-900">{cert}</span>
                    </div>
                  ))}
                </div>
              </div>
              <div className="relative">
                <div className="relative rounded-2xl overflow-hidden shadow-xl">
                  <img 
                    src="https://images.unsplash.com/photo-1454165804606-c3d57bc86b40?w=600&h=500&fit=crop"
                    alt="Quality Control"
                    className="w-full h-full object-cover"
                  />
                </div>
                {/* Quality Badge Overlay */}
                <div className="absolute -bottom-6 -right-6 bg-blue-600 text-white rounded-2xl p-6 shadow-2xl">
                  <div className="text-4xl font-bold">99.8%</div>
                  <div className="text-sm opacity-90">Quality Rate</div>
                </div>
              </div>
            </div>
          </div>
        )}

        {/* Quality Promise */}
        <div className="mt-12 bg-slate-900 rounded-2xl p-8 md:p-12 text-center">
          <h3 className="text-3xl font-bold text-white mb-4">Our Quality Promise</h3>
          <p className="text-slate-300 text-lg max-w-3xl mx-auto">
            Every leaflet that leaves our facility undergoes rigorous quality checks. We ensure every detail 
            meets regulatory compliance and pharmaceutical industry standards. Your satisfaction 
            and brand reputation are our top priorities.
          </p>
        </div>
      </div>
    </section>
  );
};

export default QualityManagement;
